/* eslint-disable @typescript-eslint/camelcase */
import { GraphPayload } from '../Visualisation/types'

export enum ChartName {
  cpm = 'cpm',
  cpc = 'cpc',
  coverage = 'coverage',
  er = 'er',
  cpv = 'cpv',
  cost = 'cost',
  budget = 'budget',
  quantity = 'quantity'
}

/** @NOTE изменил */
export type RequestPayload = {
  data: {
    cpm: GraphPayload // Стоимость 1000 показов (CPM) в Telegram
    cpc: GraphPayload // Стоимость клика (CPC) в Telegram
    coverage: GraphPayload // Какой охват получает интеграция
    er: GraphPayload // ER публикации, %
    cpv: GraphPayload // CPV на одну публикацию
    cost: GraphPayload // Сколько стоит рекламная интеграция
    budget: GraphPayload // Средний бюджет одного рекламодателя
    quantity: GraphPayload // Среднее количество публикаций одного рекламодателя
  }
  period: { min: Date; max: Date } // минимальный и максимальный период календаря (от куда - до куда данные)
  theme: Array<{ id: number; name: string }> // Тематика бизнеса
}
